import { graphql } from '@generated/gql';

export const SELECT_MODEL_PORTFOLIO_EDIT_TYPE_FETCH_HOUSEHOLD =
  graphql(/** GraphQL */ `
  query selectModelPortfolioEditTypeFetchHousehold($clientGroupId: ObjectID!) {
    fetchPortfolioReports(
      input: { filter: { householdClientGroupId: $clientGroupId } }
    ) {
      portfolioReports {
        id
        subAccounts {
          id
        }
      }
    }
  }
`);
